import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const CryptOfTheCount = {
  id: "51",
  name: "Crypt of the Count",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Crypt_Of_The_Count",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Crypt_of_the_Count',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include goods or barracks refill')
      ,
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        0.00, 0.00, 1.10, 1.10, 1.10, 1.20, 1.20, 1.20, 1.63, 1.63,
        2.45, 2.45, 2.45, 3.40, 3.40, 3.40, 3.75, 3.75, 3.75, 4.75,
        4.75, 4.75, 5.00, 5.00, 5.00, 5.40, 5.40, 5.40, 6.15, 6.15,
        6.15, 6.90, 6.90, 6.90, 7.45, 7.00, 7.00, 7.00, 7.00, 8.00,
        8.00, 8.00, 8.00, 8.00, 8.00, 9.00, 9.00, 9.00, 9.00, 9.00,
        9.00, 10.00, 10.00, 10.00, 10.00, 10.00, 10.00, 11.00, 11.00, 11.00
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          25,25,25,57,57,57,80,80,80,80,80,111,111,111,127,127,127,142,142,142,155,155,155,168,168,168,181,181,181,192,192,192,204,204,204,215,215,215,225,227,230,233,236,240,243,246,250,253,256,260,263,266,269,273,276,279,283,286,289,293
        ],
        bronzeAge: [
          30,30,30,69,69,69,96,96,96,96,96,133,133,133,152,152,152,170,170,170,186,186,186,202,202,202,217,217,217,231,231,231,244,244,244,258,258,258,270,274,278,282,286,290,294,298,302,306,310,314,318,322,326,330,334,338,342,346,350,354
        ],
        minoanEra: [
          35,35,35,80,80,80,112,112,112,112,112,155,155,155,178,178,178,198,198,198,217,217,217,236,236,236,253,253,253,269,269,269,285,285,285,301,301,301,315,321,325,330,335,339,344,349,353,358,363,368,372,377,382,386,391,396,400,405,410,415
        ],
        classicGreece: [
          40,40,40,92,92,92,129,129,129,129,129,178,178,178,203,203,203,227,227,227,249,249,249,269,269,269,289,289,289,308,308,308,326,326,326,343,343,343,360,367,372,378,384,389,395,401,406,412,418,424,429,435,441,446,452,458,463,469,475,481
        ],
        earlyRome: [
          45,45,45,103,103,103,145,145,145,145,145,200,200,200,228,228,228,255,255,255,280,280,280,303,303,303,325,325,325,346,346,346,367,367,367,386,386,386,405,410,416,422,428,435,441,447,454,460,466,473,479,485,491,498,504,510,517,523,529,536
        ],
        romanEmpire: [
          50,50,50,115,115,115,161,161,161,161,161,222,222,222,254,254,254,283,283,283,311,311,311,337,337,337,361,361,361,385,385,385,407,407,407,429,429,429,450,457,464,471,478,485,492,499,506,513,520,527,534,541,548,555,562,569,576,583,590,597
        ],
        byzantineEra: [
          55,55,55,126,126,126,177,177,177,177,177,244,244,244,279,279,279,312,312,312,342,342,342,370,370,370,397,397,397,423,423,423,448,448,448,472,472,472,495,504,511,519,527,534,542,550,557,565,573,581,588,596,604,611,619,627,634,642,650,658
        ],
        ageOfTheFranks: [
          60,60,60,138,138,138,193,193,193,193,193,266,266,266,305,305,305,340,340,340,373,373,373,404,404,404,433,433,433,462,462,462,489,489,489,515,515,515,540,547,555,563,571,580,588,596,605,613,621,630,638,646,654,663,671,679,688,696,704,713
        ],
        feudalAge: [
          65,65,65,149,149,149,209,209,209,209,209,289,289,289,330,330,330,368,368,368,404,404,404,438,438,438,470,470,470,500,500,500,530,530,530,558,558,558,586,594,603,612,621,631,640,649,659,668,677,687,696,705,714,724,733,742,752,761,770,780
        ],
        iberianEra: [
          72,72,72,164,164,164,230,230,230,230,230,318,318,318,363,363,363,405,405,405,444,444,444,482,482,482,517,517,517,550,550,550,583,583,583,614,614,614,645,654,664,674,684,695,705,715,726,736,746,757,767,777,787,798,808,818,829,839,849,860
        ],
        kingdomOfSicily: [
          79,79,79,180,180,180,253,253,253,253,253,350,350,350,399,399,399,446,446,446,488,488,488,530,530,530,569,569,569,605,605,605,641,641,641,675,675,675,710,723,734,746,758,769,781,793,804,816,828,840,851,863,875,886,898,910,921,933,945,957
        ],
        highMiddleAges: [
          87,87,87,198,198,198,278,278,278,278,278,385,385,385,439,439,439,491,491,491,537,537,537,583,583,583,626,626,626,666,666,666,705,705,705,743,743,743,781,798,811,824,837,850,864,877,890,903,916,930,943,956,969,982,996,1009,1022,1035,1048,1062
        ],
        earlyGothicEra: [
          89,89,89,206,206,206,292,292,292,292,292,409,409,409,469,469,469,527,527,527,579,579,579,631,631,631,680,680,680,726,726,726,771,771,771,815,815,815,859,880,894,908,922,936,950,964,978,992,1006,1020,1034,1048,1062,1076,1090,1104,1118,1132,1146,1160
        ],
        lateGothicEra: [
          95,95,95,221,221,221,313,313,313,313,313,439,439,439,503,503,503,565,565,565,621,621,621,677,677,677,729,729,729,779,779,779,827,827,827,874,874,874,921,940,955,970,985,1000,1015,1030,1045,1060,1075,1090,1105,1120,1135,1150,1165,1180,1195,1210,1225,1240
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
      ]),
    ),
  ]),
};

export default CryptOfTheCount;
